/* eslint-disable max-lines */
export const COLOR1 = '#000000';
export const COLOR2 = '#FD0000';
export const COLOR3 = '#FDFDFD';
export const COLOR4 = '#ffffff';
export const COLOR5 = '#661C69';
export const COLOR6 = '#444444';
export const GRAY44 = '#707070';
export const ORIENTAL_ORANGE = '#E37617';
export const WHITE = '#fff';
export const BORDER_ACC_INFO = '#c1c1c1';
export const ORIENTAL_L_GRAY = '#6D6E70';
export const ORIENTAL_D_GRAY = '#555858';
export const BLACK_COLOR = '#5558582B';
export const BORDER_ORANGE = '#F5821F';
export const SMOKE_WHITE = '#F4F4F4';
export const GRAY95 = '#F2F2F2';
export const SEASHELL_COLOR = '#FBF3EC';
export const PURE_BLACK = '#000';
export const RED_COLOR = '#FD0000';
// main header
export const MAIN_HEADER_LOGO = 'Oriental Logo';
export const VALIDATION_BACKSPACE = 'Backspace';
export const AREA_CODE = '787';

export const UPLOAD_ID_PASSPORT = 'Upload ID or Passport';
export const UPLOAD_ID_PASSPORT_ARIA_LABEL = 'Upload ID or Passport Required';

export const TOOLTIP_ALTMSG = 'More Info';
export const TOOLTIP_POSITION_TOP = 'top';
export const TOOLTIP_POSITION_TOP_END = 'top-end';
export const TOOLTIP_POSITION_RIGHT = 'right';
export const YOUR_CONSENT = 'Your Consent';
export const YOUR_ACCOUNT = 'Your Account';
export const YOUR_ACCOUNT_BUSINESS = 'Your Account/Business';
export const YOUR_INFORMATION = 'Your Information';
export const PERSONAL_INFORMATION = 'Personal Information';
export const REVIEW_INFORMATION = 'Review Terms';
export const BASIC_INFORMATION = 'Basic Information';
export const YOUR_INFORMATION_BUSINESS = 'Personal/Business Information';
export const LANGUAGE_ICON = 'Language Icon';
export const CHANGE_LANGUAGE = 'Change Language';
export const USER_LOGO = 'User Logo';
export const HELLO = 'Hello';
export const ORIENTAL_LOGO = 'Oriental-Logo';
// stepper connector
export const PRODUCT_PERSONAL = 'Personal';
export const PRODUCT_IRAFACIL = 'IRA Facil';
export const PRODUCT_IRAEDUCATION = 'Educational IRA';
export const PRODUCT_PERSONALCD = 'Personal CD';
export const PRODUCT_ABC = 'ABC';
// pages
export const CONTACT_INFO = 'contact-info';
export const BUSINESS_INFO = 'business-info';
export const PERSONAL_INFO = 'personal-info';
export const ADDRESS_INFO = 'address-info';
export const VOUCHED_SUCCESS = 'vouched-success';
export const COMPLIANCE_INFO = 'compliance-info';
export const PRODUCT_INFO = 'product-info';
export const BENEFICIARY_INFO = 'beneficiary-info';
export const MYBIZ_EN = 'My Biz Account';
export const NONPROFIT = 'NON-PROFIT';
export const ESNON_PROFIT = 'SIN FINES DE LUCRO';
export const ESCROWACCEN = 'ESCROW ACCOUNT';
export const AHORRO = 'Ahorro Comercial';
export const COMMERCIAL_EN = 'Commercial CD';
export const COMMERCIAL_ES = 'CD Comercial';
export const BUSINESS_COMPLIANCE_INFO = 'business-compliance';
export const BUSINESS_ADDITIONAL_INFO = 'business-additional-info';
export const BUSINESS_SURI = 'business-suri';
export const BUSINESS_ACCOUNT_INFO = 'business-account-info';
export const BUSINESS_COMP = 'business-comp';
export const FUNDING_INFO = 'funding-info';
export const CONSENT_INFO = 'consent-info';
export const DGIADDITIONAL_INFO = 'dgiadditional-info';
export const FINANCE_INFO = 'finance-info';
export const EDELIVERY_INFO = 'edelivery-info';
// modal product que
export const PRODUCT_KEY_TEXTONE = 'ProductModalTextOne';
export const PRODUCT_KEY_TEXTTWO = 'ProductModalTextTwo';
// session time out modal
export const SESSION_MODAL_CONTENT =
  'To protect your personal information, we clear what you entered after 15 minutes of inactivity. Restart your online application anytime.';
export const SESSION_MODAL_TITLE = 'Your session has timed out.';
export const CLOSE = 'Close';
export const SAVEYOURAPPLICATION = 'Save your application';
export const CONTINUE = 'Continue';
export const BACK = 'Back';
export const INACTIVE_MODAL_MSG =
  'Your session is about to expire in 2 minutes due to inactivity. Do you wish to continue with your application?';
export const INACTIVEMODAL_TEXT_ONE = 'InactivityTexLineOne';
export const FOOTER_MSG = `Oriental. All Rights Reserved. FDIC Member.`;
export const FOOTER_KEY = `Footer`;
export const LOADER_ALT_MSG = 'Loading...';
export const SESSION_RESTART = 'Restart my application';
export const SESSION_MODAL_KEY = 'SessionModalTextLineTwo';
export const SESSION_TIMEOUT = 'Your session has timed out.';
// snapper
export const CONTACT_MODAL = 'DBA type accounts can only be opened by the owner !';
// modal and toggle
export const MODAL_PRODUCT_CONTENT =
  'As per Oriental Bank policy we are currently unable to establish a relationship with politically exposed persons, their family members and their close associates.';
export const MODALTEXTHEADING = 'We are not able to complete your application.';
export const MODALTEXTVOUCHEDHEADING = 'We are not able to complete your application.';
export const TOGGLEID = 'Bulk Cash Services';
// BUSINESS HOME ADDRESS
export const HOMEUS_PR = 'US-PR';
export const HOMEUS_VI = 'US-VI';
export const HOME_VI = 'VI';
export const HOME_PR = 'PR';
export const BODY_STYLE = 'body-style';
export const NOTNA = 'N/A';
export const HOME_USA = 'USA';
export const EU = 'EU';
export const FOR_YOU = 'For You';
export const FOR_YOU_PAGE = 'for-you';
export const DEVELOPMENT = 'development';
export const POP = 'POP';
export const HOME_ADDRESS_TITLE = 'We’d love to hear more about you!';
export const HOME_ADDRESS_TITLE_PROG = 'We’d love to hear more about you!';

export const HOME_ADDRESS_TITLE_COMMERCIAL = 'Your Home Address Information';
// 220,201
export const ADDRESS = 'Address';
export const PHYSICAL_ADDRESS = 'Physical address';
export const ADDRESS_LINE1 = 'Address Line 1';
export const ADDRESS_LINE2 = 'Address Line 2';
// contact info
export const CONTACT_HEADING = 'We’d love to hear about you and your business!';
export const FIRST_NAME = 'First Name';
export const LAST_NAME = 'Last Name';
export const PREFERRED_CONTACT_TIME = 'Preferred Contact Time';
export const MIDDLE_INIT = 'Middle Initial';
export const SEC_LAST_NAME = 'Second Last Name';
export const EMAIL = 'Email Address';
export const MOBILE = 'Mobile';
export const MOBILE_NUMBER = 'Mobile Number';
export const GENDER = 'Gender';
export const ALT_PHONE = 'Alternate Phone';
export const MARITAL_ST = 'Marital Status';
export const CONTACT_PRODUCT_HEADING = 'Let’s start with your contact information.';
// compliance page

export const MSG_MODAL_COMPL =
  'We currently do not offer bank products for the selected business type.';
export const KNOCK_OFF_MSSG_HEAD = 'We cannot complete your application.';
export const KNOCK_OFF_MSSG_BODY =
  'You are currently not eligible to open this account due to information on your profile.';
export const KNOCK_OFF_MSSG_BODY_EMPLOYER =
  'You are currently not eligible to open this account due to information on your application.';
export const KNOCK_OFF_MSSG_BODY_ELIGIBILITY = `We’re sorry, we are not able to process your request at this time due to some information on your profile. Please continue as guest to open your account.`;
export const KNOCK_OFF_MSSG_BODY_CD = `Some details of your profile do not match our records. You can open your Certificate of deposit through the new customer process.`;
export const KNOCK_OFF_MSSG_BODY_BUNDLE = `Some details of your profile do not match our records. You can open your account through the new customer process.`;
export const FUNDING_MSSG =
  'This account is not available for processing fund transfer. Please provide another account.';
export const COMPLIANCE_PRODUCT_HEADING =
  'Understanding your business type is an important step to get started.';
export const COMPLIANCE_QUESTION_ONE =
  'Is your company involved in any of the businesses listed below?';
export const COMPLIANCE_QUESTION_ONE_ARIA_LABEL =
  'I certify that my company is not involved in any of these listed 19 businesses.';
export const COMPLIANCE_QUESTION_TWO = 'Do you have an Active SURI Merchant Number?';
export const EMPLOYER_KNOCKOFF_REASON = 'Fraudulent employer name entered by the user';
// businesscomp
export const COMP_HEADING = 'Is the company engaged in any of the following?';
export const COMP_TOGGLE1 = 'Bulk Cash Services';
export const COMP_TOGGLE2 = 'Fast Cash Services';
export const COMP_TOGGLE4 = `Private ATM's`;
export const COMP_TOGGLE5 = ' Act No. 20';
export const COMP_TOGGLE4_KEY = 'ATMRental';
export const COMP_ACT_KEY = 'Act20Cert';
export const COMP_UPLOAD_MSG = '(Upload your Act 20 Certification)';
export const COMP_UPLOAD_ATM_MSG = '(Upload ATM Rental or Purchase Documentation)';

export const COMP_MODAL_MSG =
  'As per Oriental Bank policy we are currently unable to establish a relationship with businesses which participate in internet gambling.';

// addditional info
export const ADDITIONAL_DBA = 'DBA';
export const ADDITIONAL_TITLE = 'More about your business';
export const ADDITIONAL_HEAD =
  'All fields are required to verify your information and to comply with federal regulations.';
// account info
export const ACC_INFO_DD = 'DD';
export const ACC_INFO_MM = 'MMM';
export const ACC_INFO_YYYY = 'YYYY';
export const ACC_INFO_STATE = 'state';
export const ACC_COUNTRY = 'country';
export const ACC_INFO_CITY = 'city';
export const ACC_INFO_ZIPCODE = 'zipCode';
export const ACC_VOUCHED = 'Vouched';
export const ACC_DOB = 'dob';
export const ACC_ADDRESS = 'address2';

export const WILL_YOU_BE_SIGNER = 'Will you be a signer on this account ?';

// surisearch
export const SURI_BUSINESS_NAME_MSG =
  'An active Merchant Number to confirm your Business Name and Business Owner Name is required.';
export const SURI_SER_TITLE = 'Search SURI Merchant Number';
export const ACTIVE_MERCHANT_NUMBER = 'Do you have an active Merchant Number ?';
export const SURI_SER_TEXT = 'Enter business information below:';
export const UNABLE_TO_FIND_MERCHANT_NUMBER =
  'We were unable to find your Merchant Number and details. Please enter your Merchant Number below:';
export const ENTER_MERCHANT_NUMBER = 'Enter your SURI Merchant Number details and search:';

// suri details
export const SURI_DETAIL_TITLE = 'Confirm Your Business Information';
// eslint-disable-next-line prettier/prettier
export const SURI_DETAIL_TEXT =
  'We have obtained your business information from SURI; please confirm this is your business:';
export const SURI_DETAIL_HEAD = 'Merchant Registration Certificate';

export const SURI_QUE = 'Is the information for your business correct?';
export const LOCATION_DETAILS = 'Location Details';
export const MERCHANT_DETAILS = 'Merchant Details';
export const CERTIFICATE_DETAILS = 'Certificate Details';
export const NAICS_CODES = 'NAICS Codes';
export const TYPE_OF_CERTIFICATE = 'Type Of Certificate';

// suri confirm
export const SURI_CONFIRM_HEAD = 'Confirm your SURI information';
export const BUSINESS_OWNER_HEAD = 'Business Owner Information';

export const SURI_CONFIRM_TEXT = 'Please let us know what information is incorrect:';
export const SURI_CONFIRM_LABEL1 = 'Business Owner Address';
export const SURI_CONFIRM_LABEL2 = 'Business Name';
export const SURI_CONFIRM_LABEL3 = 'Business Owner Name';
export const SURI_CONFIRM_LABEL4 = 'Merchant Number';
export const SURI_CONFIRM_LABEL5 = 'Business Address';
export const SURI_CHK = 'I certify that the above information is correct.';
export const SURI_SURI_HEAD = 'Please confirm if the information obtained from SURI is correct.';
export const SURI_SURI_HEAD_BEFORE_LOAD =
  'Let’s confirm your business information. We will use your SURI Merchant number for less data entry.';

export const COMP_ARRAY_VALUE1 = 'Money Services Business (MSB’s)';
export const COMP_ARRAY_VALUE2 = 'Bail Bond Businesses';
export const COMP_ARRAY_VALUE3 = 'Pre Paid Card Sale';
export const COMP_ARRAY_VALUE4 = 'Foreign Exchange Market';
export const COMP_ARRAY_VALUE5 = 'Pawn Shops';
export const COMP_ARRAY_VALUE6 = 'Offshore corporations';
export const COMP_ARRAY_VALUE7 = 'Collection Agencies';
export const COMP_ARRAY_VALUE8 = 'Casinos or Slot Machines';
export const COMP_ARRAY_VALUE9 = 'Foreign Correspondent Banks';
export const COMP_ARRAY_VALUE10 = 'Adult Entertainment Business';
export const COMP_ARRAY_VALUE11 = 'Precious Metal Dealers';
export const COMP_ARRAY_VALUE12 = 'Non-US Residents Aliens';
export const COMP_ARRAY_VALUE13 = 'Tarot Card Reading';
export const COMP_ARRAY_VALUE14 = 'International Banking Entities';
export const COMP_ARRAY_VALUE15 = 'Third Party Payment Processors';
export const COMP_ARRAY_VALUE16 = 'Gambling Businesses and Internet Gambling';
export const COMP_ARRAY_VALUE17 = 'Private ATM Machines';
export const COMP_ARRAY_VALUE18 = 'Credit Restoration Businesses';
export const COMP_ARRAY_VALUE19 =
  'Marijuana related business and services as well as drug paraphernilia related business';
export const SURI_MOD =
  'As per Oriental Bank policy we are currently unable to establish a relationship without an active Merchant Number.';
// DGI Screen after 3
export const DGIFINANCE_HEADING =
  'To comply with regulation it is important we obtain your financial information and evaluate your general investment knowledge. Please select below.';

export const DGIFINANCE_HEADING2 = 'Help us understand your General Investment Knowledge';
export const DGIFINANCE_HEADING1 = 'Your Financial Information';

export const DGI_STEPFOUR_HEAD =
  'Before we can open your account there is additional information about you we are required to know.';

export const DGI_ADDITIONAL_TRUST_HEAD = 'Trusted Contact Information';
export const DGI_ADDRESS = 'Address Line 1';
export const EMPLOYER_ADDRESS = 'Employer Address line 1';
export const DGI_EMP_ST = 'What is your Employment Status?';
export const DGI_REQ_QUESTIONS = 'Some questions we are required to ask:';
export const DGI_REQ_QUESTIONS_PROG = 'Some questions we are required to ask:';
export const SURI_UPLOAD_OWNERADD = '(Upload Business Owner address documentation)';
export const SURI_UPLOAD_ADD = '(Upload Business address documentation)';
export const SURI_MODAL_MSG =
  'As per Oriental Bank policy we are currently unable to establish a relationship due to the selected business type.';
export const DGI_POL_EXPOSED_QUE =
  'Are you a Politically Exposed Person or are you related to a Politically Exposed Person?';
export const DGI_POL_EXPOSED_QUE_PROG =
  'Are you a Politically Exposed Person or are you related to a Politically Exposed Person?';
export const INTEREST_WITH_HOLD = 'Interest Withholding Setup';
export const INTEREST_WITH_HOLD_TEXT =
  'Interest withholding is an option that allows any individual, estate, or trust to pay a 10% tax on non-exempt interest paid or credited to them on interest-bearing accounts. To do this, the recipient of the interest must authorize the payer to withhold this 10% tax. If this option is not chosen, the recipient must include the accrued interest as part of their gross income for the corresponding tax year and pay income tax at the normal rates. Once the option for the special 10% tax rate is chosen, it will remain in effect until the recipient decides otherwise.';
export const INTEREST_PAYMENT_METHOD_TEXT =
  'You can choose where you want the accrued interest to be deposited: reinvest it in the CD to earn more interest or deposit it in a separate account for immediate access to it.';
export const DGI_SPEC_ADULT_QUE = 'Are you a Specified Adult?';
export const DGI_TRUST_CONT_QUE = 'Do you want to provide information for a Trusted Contact?';
export const DGI_EMPLOYMENT_STATUS = 'empStatus';
export const DGI_EMPLOYMENT_YEARS = 'empYears';
export const DGI_MODAL_POLI =
  'As per Oriental Bank policy we are currently unable to establish a relationship with politically exposed persons, their family members and their close associates.';

// edelivery
export const EXISTING_USER = 'existingUser';
export const NEW_USER = 'newUser';
export const RADIO_COLOR = '#661c69';
export const MODALTEXTHEADINGEDELIVERY = 'screen 7';
export const EXEMPT_PAYEE_CODE =
  'If you are an exempt payee (if you are unsure, ask us for a complete set of IRS instructions), enter your exempt payee code (if any) here:';
export const EXEMPT_FATCA_CODE =
  'If you are exempt from FATCA reporting (if you are unsure, ask us for a complete set of IRS instructions), enter your exemption from FATCA reporting code (if any) here:';
export const OCC_PLACEHOLDER = 'Enter your occupation details';
export const OCC_LABEL = 'Occupation';
export const EMP_LABEL = 'Employer';
export const REQUIRED = 'Required';
export const YEAR_PALCEHOLDER = 'Years';
export const TIME_LABEL = 'Employment Time Period';
export const YEAR_LABEL = 'Employment Time Period Years';
export const EMP_PLACEHOLDER = 'Enter Employer Name';
export const FONT_NORMAL_14_16 = 'normal normal normal 14px/16px Arial';
export const FONT_NORMAL_22 = 'normal normal normal 22px Arial';
export const FONT_BOLD_16_18 = 'normal normal bold 16px/18px Arial';
export const FONT_BOLD_20_23 = 'normal normal bold 20px/23px Arial';
export const BACKGROUND = `${COLOR3} 0% 0% no-repeat padding-box`;
export const DGI_ACCOUNT_ONLINE_ACCESS = 'DGI Balanced Fund IRA Account Online Access';
export const DGI_EDELIVERY_HEAD =
  'Use the options below to choose how you would like to receive your account information.';
export const EMPSTATUS_LABEL = 'Employment Status';
export const EMPSTATUS_LABEL_PROG = 'Employment Status';
export const SELECT_EMPSTATUS = 'Select Employment Status';

export const EMPSTATUS_ARIALABEL =
  'What is your Employment Status ? region Employment Status Required Select Employment Status dropdown menu button';
export const EMPSTATUS_ARIALABELKEY = 'Aria Label Employment Status';
export const EMPLOYED = 'Employed';
export const SELF_EMPLOYED = 'Self Employed';
export const NOT_EMPLOYED = 'Not Employed';
export const RETIRED = 'Retired';
export const NOTEMP_SCHOOLNAME = 'Enter School Name';
export const NOTEMP_SCHOOLNAMELABEL = 'School Name';
export const NOTEMP_STUDENT = 'Student';
export const NOTEMP_CURRENTINCOME = 'Enter Source of Current Income';
export const NOTEMP_CURRENTINCOME_LABEL = 'Source of Current Income';
export const NOTEMP_NOPREVEMP = 'No Previous Employer';
export const NOTEMP_CURRUINC_PLACEHOLDER = 'Enter Source of Current Income';
export const NOTEMP_CURRUINC = 'Source of Current Income';
export const NOTCURREMP = 'Not Currently Employed';
export const NOTCURREMP_EMPLOYER = 'Enter Employer Name';
export const NOTCURREMP_EMPLOYER_LABEL = 'Previous Employer';
export const MANDATORY_FIELD_ERR = '* Mandatory Field';
export const EN = 'EN';
export const ES = 'ES';
export const ENG = 'ENG';
export const ESP = 'ESP';
export const NOTEMP_REASON = 'reason';
export const NOTEMP_CURR_ERR = '* Invalid Source of Current Income';
export const NOTEMP_SCHOOL = 'schoolName';
export const NOTEMP_SCHOOL_ERR = '* Invalid School Name';
export const NOTEMP_PRE_EMP = 'previousEmployer';
export const NOTEMP_PRE_EMP_ERR = '* Invalid Previous Employer';
export const NOTEMP_SOURCE_CURR_INC = 'sourceOfCurrentIncome';
export const DGISELF = 'employer';
export const DGISELF_EMPLOYER_ERR = '* Invalid Employer Name';
export const INVALID_FORMAT_ERR = '* Invalid Format';
export const DGISELF_BUSINESSSNAME = 'Name of your Business';
export const DGISELF_BUSINESSSNAME_LABEL = 'Enter Business Name';
export const REASON = 'Reason';
export const REASON_ARIA_LABEL = 'Reason Required Please Select Reason dropdown menu button';
export const REASON_LABEL = 'Reason Aria Label';
export const REASON_QUE = 'Please select a reason';
export const FUND_UPLOAD_VOID_CHECK = 'Upload a void check or bank statement.';
export const FUND_UPLOAD_EXPIRED_CHECK = 'Upload an expired check or bank statement';
export const INVALID_COUNTRY_MODAL_MESSAGE =
  'As per Oriental Bank Policy only US passports are accepted.';
export const MSG_COUNTRY_MODAL = "As per Oriental bank policy only US, PR, USVI ID's are accepted.";
export const NON_PUERTO_RICAN_RESIDENT = 'Non Puerto Rican Resident';
export const MSG_VOUCHED_MODAL =
  'Upload a valid ID with your selfie to continue with your application.';
export const INVALID_ERR_ADDRESS = '* Invalid address line';
export const NUMERIC = 'numeric';
export const ZIPCODE_PLAC = 'Enter Zip Code';
export const ZIPCODE = 'Zip Code';
export const CITY = 'City';
export const CITY_LAB = 'City Required Choose your city dropdown menu button';
export const STATE_LAB = 'State Required Choose your state dropdown menu button';
export const STATE = 'State';
export const COUNTRY = 'Country/Region';
export const COUNTRY_LAB = 'Country Required Choose your country dropdown menu button';
export const ADD_PLAC = 'Enter Unit Number and Street';
export const COUNTRY_ARIA = 'Aria Label Country';
export const STATE_ARIA = 'Aria Label State';
export const CITY_ARIA = 'Aria Label City';
export const INVLABEL1 = 'What is your investment knowledge?';
export const INVLABEL1_O1 = 'None';
export const INVLABEL1_O2 = 'Limited';
export const INVLABEL1_O3 = 'Moderate';
export const INVLABEL1_O4 = 'Extensive';
export const INVLABEL1_ARIA =
  'What is your investment knowledge? Required Select What is your investment knowledge? dropdown menu button';
export const INV_LABEL_2 = 'Aria Label What is your investment knowledge?';
export const PLEASE_SELECT = 'Please Select';
export const EMP_STATUS_QUE = 'What is your employment status?';
export const EMP_STATUS_QUE_PROG = 'What is your employment status?';
export const OTHER = 'Other';
export const COMPLIANCE_HEAD =
  'Before we can open your account, there is additional information about you we are required to know.';
export const COMPLIANCE_HEAD_PROG =
  'Before we can open your account, there is additional information about you we are required to ask.';
export const MIN_DEPOSIT_ERR = '* Minimum deposit required is $';
export const MAX_DEPOSIT_ERR = '* Maximum deposit allowed is $5,000';
export const ADDRESS_INFO_HEAD =
  'Validating your address is an important step in identity confirmation. Review the information below and upload proof of address if your current home address is different from the address on your ID.';
export const ADDRESS_INFO_HEAD_PROG =
  'Validating your address is an important step in identity confirmation. Review the information below and upload proof of address if your current home address is different from the address on your ID.';
export const BUSINESS_TAX_ID = 'Enter Business Tax ID';
export const BUSINESS_TAX_ID_LABEL = 'Business Tax ID';
export const WEBSITE_LABEL = 'Website';
export const WEBSITE_PLACEHOLDER = 'Enter website address';
export const ANNUAL_SALES = 'Annual Sales';
export const NUMBER_OF_EMP = 'Number of Employees';
export const NET_WORTH = 'Net Worth';
export const LESS_THAN_500000 = 'Less than $ 500,000';
export const ANNUAL_SALES_KEY1 = '$ 500,000 to $ 1 Million';
export const ANNUAL_SALES_KEY2 = '$ 1 Million to $ 5 Million';
export const ANNUAL_SALES_KEY3 = 'Over $ 5 Million';
export const NET_WORTH_KEY1 = 'Less than $ 50,000';
export const NET_WORTH_KEY2 = '$ 50,000 - $ 100,000';
export const NET_WORTH_KEY3 = '$ 100,000 - $ 250,000';
export const NET_WORTH_KEY4 = '$ 250,000 - $ 500,000';
export const NET_WORTH_KEY5 = '$ 500,000 - $ 1 Million';
export const NET_WORTH_KEY6 = 'More than $ 1 Million';
export const NO_EMP_KEY1 = '1 - 10';
export const NO_EMP_KEY2 = '11 - 50';
export const NO_EMP_KEY3 = '51 - 100';
export const NO_EMP_KEY4 = '101 - 500';
export const NO_EMP_KEY5 = 'More than 500';
export const ID_BUSINESS_TAX_ID = 'businessTaxId';
export const ID_BUSINESS_WEBSITE = 'website';
export const ID_BUSINESS_NOOFEMP = 'noOfEmployees';
export const ID_BUSINESS_NETWORTH = 'netWorth';
export const ID_BUSINESS_ANNUAL_SALES = 'annualSales';
export const INV_LIQ_NEED_LABEL = 'What are your Liquidity Needs?';
export const LOW = 'Low';
export const MEDIUM = 'Medium';
export const HIGH = 'High';
export const CONTACT_DISCLAIMER =
  'By providing this information, you are giving your consent for Oriental Bank to communicate with you through call, text message and email.';
export const LETS_START_SUB_HEAD = 'Let’s start!';
export const CONTACT_DISCLAIMER_BUNDLE =
  'By clicking continue, you authorize Oriental Bank to contact you via call, text message and email.';
export const PERSONAL_INFO_HEAD =
  "Upload your driver's license or passport first and we will complete the form using your information.";
export const PERSONAL_INFO_HEAD_PROG =
  "Upload your driver's license or passport first and we will complete the form using your information.";
export const PERSONAL_TEXT =
  'Save Time! Upload your ID to skip manually completing your information.';
export const UPLOAD_HOME_ADDRESS = 'Upload Home Address Proof';
export const PERSONAL_SUB_TEXT =
  'Your information will be encrypted and safeguarded in our system.';
export const MORE_ABOUT_YOU = 'More about you!';
export const ACC_OPENEING_DGI_HEAD =
  'Our online form helps us get to know you and your needs. Once completed, we will contact you to complete the request.';
export const ACC_OPENEING_HEAD =
  'Our online form helps us get to know you and your needs. Once completed, we will contact you to verify your identity and open your account.';
export const MAIL_HOME_ADDR_SAME = 'Mailing address same as home address';
export const DIFFERENT_MAIL_ADDR = 'My mailing address and home address are the same.';
export const TYPE_OF_ACCOUNT = 'Type of Account';
export const ACCOUNT_TYPE = 'Account type';
export const ACCOUNT_NUM = 'Account number';
export const ACCOUNT_NUMBER = 'Account Number';
export const BANK = 'Bank';
export const BANK_NAME = 'Bank Name';
export const TRANSIT_NUMBER = 'Transit Number';
export const ENTER_TRANSIT_NUMBER = 'Enter Transit Number';
export const TAX_YEAR = 'Tax Year';
export const DGI_CONT_ACC_NUM = 'DGI Account number';
export const PROD_NM_DGI_CONTRIBUTION = 'DGI Contribution';
export const DGI_FUNDING_HEAD = 'Choose how you prefer to fund your account.';
export const FUNDING_HEAD =
  'Choose how you prefer to fund your account. We will process your deposit in 24-72 hours.';
export const FUNDING_TEXT = 'How would you like to make your first deposit ?';
export const FUNDING_DISCLAIMER =
  'By clicking continue I authorize ORIENTAL BANK to make a one-time electronic debit for the amount included in the deposit amount field.';
export const DEPOSIT_AMOUNT = 'Deposit Amount';
export const MINIMUM_DEPOSIT = 'Minimum deposit';
export const MINIMUM_DEPOSIT_AMOUNT = 'Minimum deposit amount:';
export const ENTER_ACCOUNT_NUMBER = 'Enter account number';
export const CONSENT_HELPER_TEXT_DGI =
  'Before we engage in this transaction, you must understand your rights and responsibilities and provide your consent.';
export const CONSENT_HELPER_TEXT =
  'Please read the following disclosures and account documents which provide important information related to your account.';
export const DIFFERENT_NUMBER_MESSAGE = 'Please provide a different number';
export const PERCENT = '100%';
export const VOUCHED_ELEMENT = '#vouched-element';
export const INVALID = 'Invalid';
export const VALID = 'Valid';
export const DOB_FORMAT = 'dd MMM yyyy';
export const DOB_DAY = 'dob_day';
export const IS_ADDR_ID_HOME_ADDR = 'Is the address provided in the ID Proof your home address ?';
export const DEBIT_CARD_REQUIRED_TEXT = 'Yes, mail my debit card.';
export const DEBIT_CARD_NOT_REQUIRED_TEXT = 'No, I don’t want a debit card for this account.';
export const DEBIT_CARD = 'Debit Card';
export const DEBIT_CARD_REQUIRED_TEXT_V2 = 'Yes, mail my card.';
export const DIRECT_DEPOSITE = 'Direct Deposit';
export const DIRECT_DEPOSITE_SUBTEXT = 'Sign up to receive deposits directly in your account.';
export const DIRECT_DEPOSITE_RADIO_TEXT = 'Yes, I’m interested.';
export const DIRECT_DEPOSITE_RADIO_TEXT_NO = 'No, I’m not interested.';
export const DIRECT_DEPOSITE_TEXT =
  'Make paydays even better with Direct Deposit. Sign up to receive your payroll or other deposits directly in your account.';
export const DEBIT_CARD_INFO_TEXT =
  'Your account includes a Mastercard Debit Card. Do you want us to ship you the card? (Arrives in 4-6 business days)';
export const DEBIT_CARD_INFO_TEXT_1 =
  'Your account includes a Mastercard debit card. Do you want the card to be shipped? (Arrives in 4-6 business days)';

export const UPLOAD_ADDRESS_PROOF_SURI_TEXT =
  'Use the edit icon to provide the correct address information. Upload address proof!';
export const OOPS_WE_HIT_A_SNAG = 'Oops we hit a snag!';
export const SURI_KNOCK_OFF_MESSAGE =
  'As per Oriental Bank policy an active SURI Merchant number is required to open this account.';
export const BANKRUPTCY_KNOCK_OFF_MESSAGE =
  'As per Oriental Bank policy we are currently unable to establish a relationship due to the business bankruptcy.';
export const YES = 'Yes';
export const NO = 'No';
// OCR
export const UTILITY_BILL = 'Utility Bill';
export const SELECT_UTILITY_BILL_TYPE = 'Select Utility Bill Type';
export const NAME_MISMATCH_ERROR =
  'The name provided in the application doesn’t match with the utility bill uploaded. Please provide another bill with the applicant name.';
export const DONE = 'DONE';
export const FAILED = 'FAILED';
export const CLICK_TO_UPLOAD = 'Click to upload again.';
export const BUSINESS_OWNERSHIP = 'Do you have ownership in the business?';
export const ADD_SIGNER_HEADING = 'Completing your application is easy now!';
export const ADD_SIGNER_SUB_HEAD =
  'Provide a link to additional participants by providing their contact detail and selecting their role below.';
export const BUSINESS_ACC_HEAD = `Let’s Understand your Participation in the Business`;
export const BUSINESS_ACC_MORE_ABOUT_YOU = 'More About You';
export const SIGNER_ADMIN_SNACKBAR_MESSAGE =
  'You can send invite to only one person with administrative control under this application.';
export const PRODUCTUI_PAGE_KEY = 'Product Page Text';
export const PRODUCTUI_PAGE_VALUE =
  'Please review the questions below which apply to your selected account and help us understand your intended use. Answer only if applicable.';
export const UPLOAD_ID_TEXT = 'By clicking below, you will navigate to an ID verification process';
export const DOC_CHECKLIST_MESSAGE = 'Upload the required documents to open your account.';
export const DOC_CHECKLIST_HEADING_MESSAGE = 'Uploading your documents is easy!';
export const DOC_CHECKLIST_SNACKBAR_MSG =
  'Proceed by uploading whichever documents you have. We will send a link to your email to upload any missing documents.';
export const DOC_UPLOAD_LATER_HEADING = 'Upload the required documents.';
export const ATLEAST_ONE_SIGNER_MESSAGE =
  'At least one additional participant needs to be added if the applicant is neither owner or signer';
export const EMAIL_ADD_DUPLICATE_MESSAGE =
  'Please provide an email address different from other applicants.';
export const EDELIVERYKEYDESC =
  'Before we can open your account we are required to obtain your consent on the following:';
export const INFO_SHOWN_BY_SYST_CORRECT =
  'The information of my business shown by the system is correct.';
export const I_CONFIRM_CHANGES_MADE_CORRECT = 'I confirm the changes made by me are correct.';
export const PROGRESA_CONTIGO = 'Progresa Contigo';
export const PROGRESA_CONTIGO_HEADING = `Our online form helps us get to know you and your needs. Upload driver's license or passport first and we will complete the form using your information.`;
export const UPLOAD_ADDRESS_GIF_TEXT =
  'Upload a utility bill with your name and address issued within the last 60 days.';
export const LIBRE_ACCOUNT = 'Libre Account';
export const CUENTA_LIBRE = 'Cuenta Libre';
export const E_STATEMENTS = 'e-Statements';
export const ESTATEMENT_TEXT =
  'Your Libre account includes e-Statement! You will be able to access your account statements electronically, free of charge, when you sign up for our';
export const ESTATEMENT_BANKING = ' Online Banking.';
export const ADDRESSLINE1_MAX_ERR = '* Address Line 1 should have max 30 characters.';
export const ADDRESSLINE2_MAX_ERR = '* Address Line 2 should have max 30 characters.';
export const E_STATEMENT_MONTHLY_FEE =
  'If you prefer your statements on paper, you will have a monthly service charge of $5.00.';
export const E_STATEMENT_FEE_WAIVED_AGED =
  'Accounts whose primary signer is between ages 13 to 23 or 65 years of age or older, are exempt from this fee.';
export const PROGRESA_CONTIGO_ESTATEMENT = 'Electronic Statements';
export const PROGRESA_CONTIGO_ESTATEMENT_TEXT =
  'Your Progresa Contigo account includes e-Statement! You will be able to access your account statements electronically, free of charge, when you sign up for our';
export const PROGRESA_CONTIGO_MONTHLY_FEE =
  'If you prefer your statement on paper, you will have a monthly service charge of $2.00.';
export const PROGRESA_CONTIGO_FEE_EXEMPTION =
  'Accounts whose primary signer is 65 years of age or older, are exempt from this fee.';
export const PROGRESA_CONTIGO_BANKING = ' Online Banking.';
export const ID_UPLOAD_TEXT =
  "Upload your photo ID to open your account. The ID's accepted are your driver's license, passport, passport card or US military ID";
export const SAVE_YOUR_PROGRESS = 'Save your progress';
export const PLEASE_VERIFY_YOUR_DETAILS = 'Please verify your details';
export const PLEASE_VERIFY_YOUR_INFO = 'Please verify your information.';
export const SAVE_APP_CONTACT_DISCLAIMER = `Your application progress will be saved and you will have 30 days to complete it. Once saved, you'll receive an email with instructions on how to retrieve and complete your application.`;
export const ADDRESS_EDIT_MODAL_TITLE = 'We noticed you want to edit your address';
export const ADDRESS_EDIT_REASON = 'What is the reason:';
export const ADDRESS_EDIT_RADIO_ONE = 'That is my address, but it has errors.';
export const ADDRESS_EDIT_RADIO_TWO = 'I have a new address.';
export const CAROUSAL_LOADER_TEXT =
  'It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout.';
export const WAITING_PERIOD_45_DAYS_ACCOUNT_OPENING =
  'You have 90 days from the date your account is opened to make your first deposit.';
export const RECEIVE_ACC_DETAILS_ON_EMAIL =
  'You will receive an email with your new account details in the next 24 to 48 hrs.';
export const COMBINED_STATEMENT =
  'Your account includes combined statement. You will be able to access you two statements together.';
export const RECEIVE_ACC_DETAILS_ON_EMAIL_PROG =
  'You will receive an email with your new account details in the next 24 to 48 business hours.';
export const REVIEW_APPLICATION =
  'We will review your application details in order to open your account.';
export const YOU_SUBMITTED_APP = 'You have successfully submitted your application.';
export const THANK_YOU = 'Thank You!';
export const WHAT_COME_NEXT = 'What comes next?';
export const INVALID_DATE = '* Invalid Date';
export const DATE_FORMAT_EN = 'mm/dd/yyyy';
export const DATE_FORMAT_ES = 'dd/mm/aaaa';
export const CAROUSEL_ONE_TITLE = 'Deposit, withdraw, send and receive money at your convenience.';
export const CAROUSEL_TWO_TITLE = 'Manage your money wherever you want, whenever you want.';
export const CAROUSEL_TWO_SUB_TITLE = 'With Online Banking and Digital Banking';
export const PHOTO_DEPOSIT = 'PHOTO Deposit';
export const LIVE_TELLER = 'Live Teller';
export const AUTOMATED_TELLER_MACHINE = 'Automated Teller Machine';
export const ATH_MOVIL = 'ATH Móvil';
export const PEOPLE_PAY = 'People Pay';
export const errorTypes = [
  'ERROR_OTP_VERIFY_FAILED',
  'ERROR_OTP_VERIFICAR_FALLO',
  'ERROR_ACCOUNT_LOCKED_TEMP',
  'ERROR_CUENTA_LOCKED_TEMP',
  'ERROR_ACCOUNT_LOCKED_TEMP_ONE_HR',
  'ERROR_CUENTA_LOCKED_TEMP_ONE_HR',
  'ERROR_ACCOUNT_LOCKED',
  'ERROR_CUENTA_BLOQUEADA',
  'ERROR_OTP_EXPIRED',
  'ERROR_OTP_EXPIREED',
];
export const CONTENT_TYPE = 'application/x-www-form-urlencoded';
export const ELITE_ACCOUNT_EN = 'Elite Account';
export const ELITE_ACCOUNT_ES = 'Cuenta Elite';
export const ESTATEMENT_SIGNER_FEE_EXEMPT =
  'Accounts whose primary signer is older than 65 years of age or older, are exempt from this fee.';
export const DEFICIT_TRANSFER_TEXT =
  'This account requires maintaining a minimum amount of $1,000.00 in the checking section. To help you maintain this balance, we will automatically transfer from your savings account the necessary amount to maintain this limit as you make transactions.';
export const EXCESS_TRANSFER_TEXT =
  'In order for you to earn the highest interest rate payments on your savings, we can automatically transfer the excess of the amount you want. Tell us if you prefer to activate this function along with the maximum amount and we will take care of the rest.';
export const EXCESS_TRANSFER_NOTE =
  'Note: We will transfer the excess of this amount from your checking to your savings section.';
export const FEATURE_INFO = 'feature-info';
export const KNOCK_OFF_MSSG_BODY_ELITE =
  'Some details of your profile do not match our records. You can open your Elite account through the new customer process, or call us at 787.434.8458 for support with the process.';
export const KNOCK_OFF_MSSG_BODY_AHORRA =
  'Some details of your profile do not match our records. You can open your Ahorra account through the new customer process.';
export const KNOCK_OFF_MSSG_BODY_INFO =
  'We will need more information to complete this request, please continue as guest to open your account.';
export const ACCURED_INTEREST_METHOD = 'Accrued interest method';
export const SELECT_METHOD = 'Select method';
export const INTEREST_PAYMENT_METHOD = 'Interest Payment Method';
export const SOURCE_OF_FUNDS = 'Source of funds';
export const SOURCE_OF_FUNDS_PLACEHOLDER = 'Select your source of funds';
export const CONTENT_TYPE_APP_JSON_CHAR = 'application/json; charset=UTF-8';
export const SALES = 'sales';
export const THANKYOUSCREEN_TOOLTIP_CONTENT =
  'Please write down your account number. You will need it to subscribe to Online Banking.';
export const DGI_TRUST_TOOLTIP = 'DGITrustTooltip';
export const DGI_TRUST_TOOLTIP_VALUE =
  "A trusted contact is an individual authorized by an investor to be contacted by their financial firm in limited circumstances, such as concerns about activity in the investor's account or if the firm has been unable to reach the investor after numerous attempts.";
export const CD_COMPLETE_TEXT = 'Your new CD is almost complete!';
export const CD_TERMS =
  'Please read and agree the final terms of your Certificate of Deposit in order to open your account.';
export const INTEREST_WITH_HOLD_QUESTION =
  'Do you wish Oriental Bank to withhold interest for this account? If so select the option included below.';
export const DEPOSIT_MAX_AMOUNT_ERROR = '* Amount Cannot Exceed 1,000,000';
export const VOUCHED_FAILED = 'vouched-failed';
export const DEBIT_CARD_SUBTEXT =
  'Do you want us to ship you the card? (Arrives in 4-6 business days)';
export const E_STATEMENT_TITLE = 'Your Bundle account includes';
export const E_STATEMENT_SUBTEXT_FREE =
  'e-Statement! Access your statements electronically, free of charge.';
export const E_STATEMENT_SUBTEXT_PAID =
  'If you prefer paper statements, there will be a monthly service charge of $2.00 for your Ahorra Account and $5.00 for your Libre Account.';
export const STATEMENT = 'Statements';
export const STMT_TEXT =
  'Your Bundle account includes e-Statement!  Access your statements electronically, free of charge.';
export const SIGNER_FEE_MESSAGE =
  'Accounts whose primary signer is between the ages of 13 to 23 or 65 or older are exempt from this fee.';
export const VOUCHED_TEXT =
  "We recommend you to complete your application in a quiet and private place. Acceptable forms of identification are: valid driver's license, passport or passport card.";
export const VOUCHED_MAIN_TEXT = 'Have your ID nearby and be ready to take a selfie';

export const SAVE = 'Save';
export const VOUCHED_ERROR = 'Oops! There was an error';
export const VOUCHED_ERROR_SUBTEXT =
  'Please re-upload your ID and take a selfie to continue with the application.';
export const TRY_AGAIN = 'Try again';
export const APPLY_TWO_ACCOUNTS = 'Do you want to apply the same selection to both accounts?';
export const YOUR_CONSENT_SUBTEXT =
  'Before continuing, you must review your rights and responsibilities and give your consent.';
export const CONSENT_TEXT =
  'I certify that I have read the disclosures below and accept the terms and conditions thereof.';
export const BUNDLE_ACCOUNT = 'Libre Account and Ahorra Account';
export const AHORRA_ACCOUNT_ENGLISH = 'Ahorra Account';
export const BUNDLE_SUBTEXT = 'Confirm your details';
export const DIRECT_DEPOSIT_SUBTEXT =
  'You will be able to receive your payroll up to 2 business days in advance.';
export const MASTERCART_DEBIT_CARD = 'Mastercard Debit Card';
export const MASTERCARD_SUBTEXT =
  'Would you like us to send your card to you? (Arrives in 4-6 business days)';
export const ACCOUNT_STATEMENTS = 'Account statements';
export const STATEMENT_TITLE =
  'Access your account statements electronically and without fees through our';
export const STATEMENT_SUB = ' Online Banking';
export const AND = ' and';
export const STATEMENT_SUBTEXT = ' Mobile app.';
export const PREFERRED_TIME = 'Preferred time to be contacted';
export const ESIGN_DISCLOSURE_EN = 'E-Sign Disclosure';
export const ESIGN_DISCLOSURE_ES = 'Divulgación de Documentos Electrónicos';
export const ESIGN_DISCLOSURE_BUNDLE = 'E-Sign Disclosure Bundle';
export const LIBRE_TISA_EN_URL =
  'https://orientalbank.com/assets/Pdfs/BankAccounts/terms_and_conditions_CUENTA_LIBRE.pdf';
export const LIBRE_TISA_ES_URL =
  'https://orientalbank.com/assets/Pdfs/BankAccounts/TISA_CUENTA_LIBRE.pdf';
export const AHORRA_TISA_EN_URL =
  'https://orientalbank.com/assets/Pdfs/BankAccounts/terms_and_conditions_AHORRA.pdf';
export const AHORRA_TISA_ES_URL =
  'https://orientalbank.com/assets/Pdfs/BankAccounts/TISA_AHORRA.pdf';
export const BOOST_YOUR_SAVINGS = 'Boost your savings with';
export const OPEN_YOUR_LIBRE_ACC_TEXT =
  'Open your Libre Account in minutes and add benefits to your Ahorra Account.';
export const VIEW_BENEFITS = 'View Benefits';
export const TERMS_AND_COND = 'Terms and Conditions';
export const OPEN_LIBRE_ACCOUNT = 'Open Libre Account';
export const OPEN_AHORRA_ACCOUNT = 'Open Ahorra Account';
export const OPEN_YOUR_AHORRA_ACC_TEXT = 'Open your Ahorra Account in minutes and activate Libre+';
export const HOW_TO_ACTIVATE_AHORRA = 'How to activate it?';
export const HOW_TO_ACTIVATE_LIBRE = 'How to activate them?';
export const HOW_TO_GET_LIBRE = 'With Libre Account you get:';
export const TEXT_AHORRA_LIBREPLUS =
  '*Minimum initial deposit of $1. No fees will be charged during the first three cycles. After that, you must maintain a minimum balance of $500 to avoid additional charges.';
export const DETAILS_ABOUT_NEW_ACC = 'Details about your new account:';
export const DETAILS_ABOUT_NEW_ACC_BENEFITS = 'Details about your new account and other benefits:';
export const LIBRE_AHORRA_BUNDLE = 'Libre Account and Ahorra Account';
export const LIBRE_AHORRA_BUNDLE_ES = 'Cuenta Libre y Cuenta Ahorra';
export const FUNDING_DEPOSIT_QUESTION =
  'How do you want to make your first deposit for your Ahorra Account?';
export const INVALID_FORMAT_ERR_BUNDLE = 'Oops! Invalid format.';
export const PROFESSION_DETAILS = 'Enter the details of your profession';
export const EMPLOYER_DETAILS = 'Enter the name of the employer';
export const PREVIOUS_EMPLOYER = 'Enter the name of your previous employer';
export const CLICK_TO_VIEW = 'Click to view the document';
export const DEPOSIT_PLAID = 'Deposit with another account (via Plaid)';
export const VERIFICATION_PENDING =
  'Your account verification is pending. We will send you an email to validate the micro-deposits. However, you must continue with your application so that we can complete the verification of your account.';
export const PLAID_SUCCESS_TEXT =
  'We have verified your bank account details, and you are ready to begin.';
export const DATE_FORMATBUNDLE_ES = 'dd/mm/yyyy';
export const CHANGE_ADDRESS = 'I want to change my address';
export const UPLOAD_PROOF = 'Upload proof of physicial address';
export const UPLOAD_PROOF_SUBTEXT =
  'Upload a utility bill you have received within the last 60 days that shows your name and address.';
export const MAIL_ADDRESS = 'My mailing address is the same as my physical address';
export const VERIFICATION_COMPLETED = 'Verification Completed';
export const ROUTING_NUMBER = 'Routing number';
export const ENTER_ROUTING_NUMBER = 'Enter routing number';
export const BUNDLE_FUNDING_DISCLAIMER =
  'By clicking “Continue”, I authorize Oriental Bank to make a one-time electronic debit for the amount included in the “Deposit amount” field.';

export const APPLICATION_REVIEWED =
  'Your application has been successfully reviewed, and we are just a few steps away from opening your Libre and Ahorra Account.';
export const RECEIVE_ACCOUNTS_DETAILS =
  'You will receive an email with your new accounts details in the next 24 to 48 hrs.';
export const ORIENTAL_BANK = 'Visit orientalbank.com';
export const OPEN_BUNDLE_ACCOUNT = 'Get ready to open your Libre and Ahorra Account!';
export const WELCOME_MSG = 'welcome to Oriental Bank!';
export const OPEN_DATE = 'Opened Date';
export const ROUTE_TRANSIT_NUMBER = 'Route and transit number';
export const IS_POLITICALLY_EXPOSED_TOOLTIP_BUNDLE =
  'The term “politically exposed person” refers to a current or former senior foreign political figure, their immediate family, and their close associates.';
export const ACCESS_SAVED_APPLICATION =
  'Enter the following information to access your saved application.';
export const ACCESS_APPLICATION = 'Enter the following information to access your application.';
export const SAVED_APPLICATION_DISCLAIMER1 =
  'The data entered will be verified against the information saved from the previous application. The terms and conditions may have changed since the application was saved.';
export const SAVED_APPLICATION_DISCLAIMER2 =
  'By clicking continue, you authorize Oriental Bank to contact you by phone, text message, and email.';
export const SAVE_YOUR_PROGRESS_DISC_BUNDLE =
  'Your progress on the application will be saved, and you will have 30 days to complete it. Once saved, you will receive an email with instructions on how to resume and finish it.';
export const REQUEST_FAIL = 'We cannot process your request';
export const COMPLIANCE_POLICY =
  'Due to Oriental Bank policy, we are currently unable to establish relationships with politically exposed persons, their family members, and their close associates.';
export const ERROR_OCCURRED = 'Oops! An error occurred.';
export const NO_ACTIVE_APPLICATION = 'No active applications were found.';
export const NOT_ELIGIBLE = 'You are not eligible to open this account.';
export const NOT_ELIGIBLE_DESCRIPTION =
  'Based on the information in your application, you are currently not eligible to open this account.';
export const VERIFICATION_INPROGRESS = 'Verification in progress';
export const SESSION_EXPIRED = 'Your session has expired.';
export const SESSION_EXPIRED_MSG =
  'To protect your personal information, we delete the data entered after 15 minutes of inactivity. You can restart your online application at any time.';
export const SESSION_INACTIVITY_MSG =
  'Your session will expire in 2 minutes due to inactivity. Would you like to continue with your request?';
export const COUNTRY_ES_BUNDLE = 'País';
export const COUNTRY_ES = 'País/Región';
export const SAVE_YOUR_PROGRESS_BUNDLE = 'Save your progress,';
export const SAVE_YOUR_PROGRESS_ERROR = `Your application progress will be saved and you will have 30 days to complete it. Once saved, you'll receive an email with instructions on how to retrieve and complete your application.`;
export const CD_IRA = 'CD IRA';
export const CONTRIBUTION_YEAR = 'Contribution year';
export const REMAINING_MAX_YEAR = 'Remaining this Max allowed year';
export const DEFAULT_PAYMENT_METHOD = 'Default payment method';
export const ADJUST_TO_ALLOWED_LIMIT = 'Adjust to the allowed limit';
export const CD_IRA_COMPLETED = 'Your new CD IRA is almost complete!';
export const AGE_LIMIT_CD_IRA = 'Age limit exceeded for CD IRA';
export const CONTRIBUTION_LIMIT_CD_IRA = 'Contribution limit exceeded for CD IRA';
export const IRA_EDUCATIVA = 'IRA Educativa';
export const EDUCATIVE_IRA_COMPLETED = 'Your new IRA Educativa is almost complete!';
export const SAME_BENEFICIARY_ADDRESS = 'Use my home address for my beneficiary';
export const LEGAL_GUARDIAN = 'Are you the legal guardian of the beneficiary?';
export const THANKYOU_SCREEN_BUTTON_HEADER_DS = 'View your new account details in Online Banking.';
export const THANKYOU_SCREEN_BUTTON_HEADER_WC =
  'Your account will be available in your Oriental app in approximately 10 minutes.';
export const ABC_BENEFICIARY_KEY = 'ABC Beneficiary Screen Description';
export const IS_STUDENT = 'Is the beneficiary a student?';
export const EDUCATIVA_BENEFICIARY_HEADING_ADD =
  'Add a beneficiary to start saving for their college education.';
export const EDUCATIVA_BENEFICIARY_HEADING_VIEW =
  'Here you can view your beneficiaries and their annual balances.';
export const ABC_BENEFICIARY_HEADING_ADD = 'Add a beneficiary to start saving for their future.';
export const ABC_BENEFICIARY_HEADING_VIEW = 'Here you can view your beneficiaries';
export const ABC_BENEFICIARY_INELIGIBLE = 'Your Beneficiary is not eligible for an ABC Account';
export const ABC_BENEFICIARY_INELIGIBLE_TEXT1 =
  'To open an ABC Account, your beneficiary needs to be 18 years old or younger.';
export const ABC_BENEFICIARY_INELIGIBLE_TEXT2 =
  'If your child is older, they can open their own Ahorra Account and transform their financial future.';
export const LEARN_ABOUT_AHORRA = 'Learn more about the Ahorra Account';
export const SUBMIT_TAX_EXTENSION_DOCUMENT =
  'After April 15, it is required to submit evidence of extension approved by the Puerto Rico Treasury Department.';
export const TOOLTIP_TAX_EXTENSION_DOCUMENT =
  'We require this document to verify that you have evidence of extension approved by the Puerto Rico Treasury Department in order to proceed with the opening of your IRA account.';
export const TOOLTIP_ABC_BIRTH_PROOF =
  "We require the birth certificate to verify the beneficiary's identity and eligibility for the ABC Account.";
export const TOOLTIP_EDUCATIVA_BIRTH_PROOF =
  "We require the birth certificate to verify the beneficiary's identity and eligibility for the IRA Educativa.";
export const WHAT_COME_NEXT1 = 'What Come Next?';
export const ABC_REVIEW_APPLICATION =
  'We will review your application details in order to open the account for';
export const ABC_RECEIVE_ACC_DETAILS_ON_EMAIL =
  'You will receive an email with the new account details in the next 24 to 48 business hours.';
export const EMPLOYEE_NUMBER = 'Employee Number';
export const EMPLOYEE_NAME = 'Employee Name';
export const COST_CENTER = 'Cost Center';
export const BRANCH = 'Branch';
export const LANGUAGE = 'Language';
export const COMMERCIAL_CUSTOMER = 'Commercial Customer';
export const EMP_NO_PLACEHOLDER = 'Enter Employee Number';
export const EMP_NAME_PLACEHOLDER = 'Enter Employee Name';
export const COST_CENTER_PLACEHOLDER = 'Enter Cost Center';
export const BRANCH_PLACEHOLDER = 'Enter Branch';
export const CUSTOMER_NAME_PLACEHOLDER = 'Enter Customer Name';
export const BENEFICIARY_SSN = 'beneficiarySSN';
export const ALLOWED_LOCATIONS = ['PR', 'VI'];
export const ALLOWED_LANGUAGES = ['EN', 'ES'];
export const BANK_BASE_URL = 'https://orientalbank.com';
export const FALLBACK_URL = `${BANK_BASE_URL}/`;
export const ORIENTAL_SHAREPOINT_URL =
  'https://orientalbank2016.sharepoint.com/sites/OrientalIntranet/SitePages/External-web-links.aspx';
